import React from 'react';

import {
  DESKTOP_MIN_WIDTH,
  LARGE_TABLET_MIN_WIDTH,
} from 'constants/breakpoints';

import OverflowMenu from '../overflow-menu';
import ShareButtonsWrapper from '../share-buttons';
import ViewerInsightsButton from '../viewer-insights/button';
import ViewerInsightsForNonEditors from '../viewer-insights/simple';

import HeaderPortal from 'components/layout/header/portal';
import MediaQuery from 'components/media-query';

export default ({
  downloadUrl,
  triggerFocusTitle,
  user,
  video,
  currentUserIsOwner,
  videoIsTeamShared,
}) => {
  return (
    <HeaderPortal>
      <MediaQuery query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}>
        <div className="flex shrink:0">
          <div className="flex ml:auto">
            {/* only show on screen sizes where we show the right panel */}
            <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
              <ViewerInsightsForNonEditors />
              <ViewerInsightsButton user={user} />
            </MediaQuery>
            <ShareButtonsWrapper
              className="relative"
              currentUserIsOwner={currentUserIsOwner}
              shareModalShouldOpenAsDropdown
              user={user}
              video={video}
              videoIsTeamShared={videoIsTeamShared}
            />
            <div className="ml:small flex items:center">
              <OverflowMenu
                downloadUrl={downloadUrl}
                triggerFocusTitle={triggerFocusTitle}
                user={user}
                video={video}
              />
            </div>
          </div>
        </div>
      </MediaQuery>
    </HeaderPortal>
  );
};
